'use client'
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'

export default function CombineMoreInfo({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const [mobileModalOpen, setMobileModalOpen] = useState(isOpen)
  const [modalLargeOpen, setModalLargeOpen] = useState(isOpen)

  const isMobile = useBreakpointValue({ base: true, sm: false })

  const handleCloseLargeModal = () => {
    setModalLargeOpen(false)
    onClose()
  }

  const handleCloseMobileModal = () => {
    setMobileModalOpen(false)
    onClose()
  }

  useEffect(() => {
    if (isMobile) {
      setMobileModalOpen(isOpen)
      setModalLargeOpen(false)
    } else {
      setModalLargeOpen(isOpen)
      setMobileModalOpen(false)
    }
  }, [isMobile, isOpen])

  return (
    <>
      <Modal isOpen={modalLargeOpen} onClose={handleCloseLargeModal} isCentered>
        <ModalOverlay />
        <ModalContent mx={18} borderRadius={'16px !important'}>
          <ModalBody p={0} borderTopRadius={28}>
            <Flex className="mb-24 mt-5 flex-col justify-center px-4">
              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Estimated Total Balance
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>

              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the
                <span className="font-bold"> net amount of balance</span> that a
                user has earned. It’s a estimate because it is{' '}
                <span className="font-bold">yet to be verified</span> .
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Payout Balance
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the amount of balance that a user will be{' '}
                <span className="font-bold">paid</span> at the{' '}
                <span className="font-bold">7th of current month</span>.
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  {/* Earnings as a Creator */}
                  Watch Time Earnings as a Creator
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the amount of Watch Time Earnings that a user generates
                by <span className="font-bold"> uploading content</span> on
                LYKSTAGE.
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  {/* Earnings as a Viewer */}
                  Watch Time Earnings as a Viewer
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the amount of Watch Time Earnings that a user generates
                by <span className="font-bold">watching content</span> on
                LYKSTAGE.
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Other Earnings
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the amount of earnings that a user generates
                by <span className="font-bold">bonuses and promotions</span> on
                LYKSTAGE.
              </Text>
            </Flex>

            <Flex className="absolute bottom-[4%] w-full flex-col gap-3 px-4">
              <Button
                className="w-full py-2 font-semibold"
                color={'white'}
                bg={'lyk-green'}
                border="2px solid white"
                _hover={{
                  border: '2px solid white',
                }}
                onClick={handleCloseLargeModal}
              >
                Go Back
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* MOBILE VIEW */}
      <Box>
        <Modal
          isCentered={false}
          onClose={handleCloseMobileModal}
          isOpen={mobileModalOpen}
          motionPreset="slideInBottom"
        >
          <ModalOverlay />
          <ModalContent
            borderTopRadius={28}
            position="fixed"
            pb={84}
            bottom="0"
            margin="0 auto"
            width="100%"
            maxWidth="600px"
            display={{ base: 'block', sm: 'none' }}
          >
            <ModalBody p={0} borderTopRadius={28}>
              <Flex className="mb-2 mt-5 flex-col justify-center px-4">
                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Estimated Total Balance
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>

                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the
                  <span className="font-bold"> net amount of balance</span> that
                  a user has earned. It’s a estimate because it is{' '}
                  <span className="font-bold">yet to be verified</span> .
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Redeemable Balance
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the amount of balance that a user can{' '}
                  <span className="font-bold">redeem</span> at any point.
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    {/* Earnings as a Creator */}
                    Watch Time Earnings as a Creator
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the amount of Watch Time Earnings that a user
                  generates by{' '}
                  <span className="font-bold"> uploading content</span> on
                  LYKSTAGE.
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    {/* Earnings as a Viewer */}
                    Watch Time Earnings as a Viewer
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the amount of Watch Time Earnings that a user
                  generates by{' '}
                  <span className="font-bold">watching content</span> on
                  LYKSTAGE. It also includes any earnings through{' '}
                  <span className="font-bold">bonuses and promotions</span>.
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Other Earnings
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the amount of earnings that a user
                  generates by{' '}
                  <span className="font-bold">bonuses and promotions</span> on
                  LYKSTAGE.
                </Text>
              </Flex>

              <Flex className="absolute bottom-[4%] w-full flex-col gap-3 px-4">
                <Button
                  className="w-full py-2 font-semibold"
                  color={'white'}
                  bg={'lyk-green'}
                  border="2px solid white"
                  _hover={{
                    border: '2px solid white',
                  }}
                  onClick={handleCloseMobileModal}
                >
                  Go Back
                </Button>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </>
  )
}
